"use strict";

(function () {
  modalBeforeInit();
  document.addEventListener('readystatechange', function (e) {
    return e.target.readyState === 'complete' && modalsInit();
  });
})();
var KEYCODE_TAB = 9;
var KEYCODE_ENTER = 13;
var KEYCODE_ESC = 27;
var currentFocus;
function trapFocus(element) {
  var autofocus = element.querySelector("[autofocus]");
  var focusable = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), select:not([disabled]), .modal__close:not([disabled]):not(.modal__background), label:not([disabled])');
  var first = focusable[0];
  var last = focusable[focusable.length - 1];
  if (focusable) {
    focusable[element.dataset.videoId || focusable.length === 1 ? 0 : 1].focus();
    focusable.forEach(function (el, index) {
      if (el.tagName != 'A' && el.tagName != 'BUTTON' && el.tagName != 'TEXTAREA' && el.tagName != 'INPUT' && el.getAttribute("tabindex") == null) {
        el.setAttribute('tabindex', 0);
      }
      el.addEventListener('keydown', function (e) {
        return (e.key === 'Enter' || e.keyCode === KEYCODE_ENTER) && el.click();
      });
    });
  }
  autofocus && setTimeout(function () {
    return autofocus.focus();
  }, 100);
  element.addEventListener('keydown', function (e) {
    var isTab = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTab) return;
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus(); /* shift + tab */
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus(); /* tab */
    }
  });
}
function modalBeforeInit() {
  document.querySelectorAll('*:not(body) .modal').forEach(function (modal) {
    document.body.appendChild(modal);
  });
}
function modalsInit() {
  var body = document.body;
  var main = document.querySelector('.page');
  var modalOpeners = document.querySelectorAll('[data-modal-open]:not(.ready)');
  main.setAttribute('aria-hidden', 'false');
  var getPlayer = function getPlayer(videoId) {
    return videojs && videojs(videoId);
  };
  var getModal = function getModal(id) {
    return document.querySelector('[data-modal-id="' + id + '"]');
  };
  var buildModalDetail = function buildModalDetail(target) {
    var detail = {
      modal: target
    };
    if (target.dataset.modalId) detail.id = target.dataset.modalId;
    if (target.dataset.modalName) detail.name = target.dataset.modalName;
    if (target.dataset.modalGroup) detail.group = target.dataset.modalGroup;
    return detail;
  };
  var modalClose = function modalClose(target) {
    target.classList.remove('modal-opened');
    body.classList.remove('overlay-visible');
    target.setAttribute('aria-hidden', 'true');
    main.setAttribute('aria-hidden', 'false');
    currentFocus.focus();
    target.dataset.videoId && getPlayer(target.dataset.videoId).pause();
    // Dispatch custom event on close
    target.dispatchEvent(new CustomEvent('modal:close', {
      bubbles: true,
      detail: buildModalDetail(target)
    }));
  };
  var modalOpen = function modalOpen(target, current) {
    target.classList.add('modal-opened');
    body.classList.add('overlay-visible');
    target.setAttribute('aria-hidden', 'false');
    main.setAttribute('aria-hidden', 'true');
    trapFocus(target);
    currentFocus = current;
    target.dataset.videoId && getPlayer(target.dataset.videoId).play();
    // Dispatch custom event on open
    target.dispatchEvent(new CustomEvent('modal:open', {
      bubbles: true,
      detail: buildModalDetail(target)
    }));
  };
  if (modalOpeners) {
    modalOpeners.forEach(function (item) {
      item.classList.add('ready');
      var modal = getModal(item.dataset.modalTarget);
      if (modal !== null) {
        modal.classList.add('ready');
        var closes = modal.querySelectorAll('[data-modal-close]');
        closes.forEach(function (close) {
          close.addEventListener('click', function (e) {
            modalClose(modal);
            e.stopPropagation();
          }, false);
          close.addEventListener('keydown', function (e) {
            return e.key === 'Enter' || e.keyCode === KEYCODE_ENTER && modalClose(modal, item);
          });
        });
        item.addEventListener('click', function () {
          return modalOpen(modal, item);
        });
        item.addEventListener('keydown', function (e) {
          return e.key === 'Enter' || e.keyCode === KEYCODE_ENTER && modalOpen(modal, item);
        });
        item.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.keyCode === KEYCODE_SPACE) {
            e.preventDefault();
            modalOpen(modal, item);
          }
        });
        document.addEventListener('keydown', function (e) {
          if (modal.classList.contains('modal-opened') && (e.key === 'Escape' || e.keyCode === KEYCODE_ESC)) modalClose(modal, item);
          e.stopPropagation();
        });
      }
    });
  }
}